module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.2-231.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.3.2.md
// module id = 673
// module chunks = 308